var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-wrapper" } }, [
    _c(
      "ul",
      {
        staticClass: "sidebar-nav nav-pills nav-stacked",
        attrs: { id: "menu" }
      },
      [
        _vm._l(_vm.menu_data, function(menu, index) {
          return [
            index == 0
              ? [
                  _c(
                    "li",
                    {
                      staticClass: "company",
                      attrs: { id: "company_" + menu.id }
                    },
                    [
                      menu.locations.length > 0
                        ? [
                            _c(
                              "label",
                              {
                                staticClass: "active tree-toggle nav-header",
                                attrs: { title: menu.name },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.toggleMenu(menu)
                                  }
                                }
                              },
                              [
                                menu.logo != ""
                                  ? _c(
                                      "div",
                                      { staticClass: "Sidebar_First_Letter" },
                                      [_c("img", { attrs: { src: menu.logo } })]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "Sidebar_First_Letter" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getFirstChar(menu.name)
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    ),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.stringTrim(menu.name, 18)) +
                                    " "
                                ),
                                _c("i", {
                                  staticClass: "fa fa-angle-up",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass: "nav nav-list tree",
                                staticStyle: { display: "block" },
                                attrs: { id: "ul_home" }
                              },
                              [
                                _vm._l(menu.locations, function(
                                  location,
                                  index
                                ) {
                                  return [
                                    _c(
                                      "li",
                                      {
                                        attrs: { id: "location" + location.id }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              title: menu.name,
                                              to: {
                                                name: "ViewContactList",
                                                params: {
                                                  company: menu.id,
                                                  location: location.id
                                                }
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.stringTrim(
                                                    location.name,
                                                    22
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        : [
                            menu.logo != ""
                              ? _c(
                                  "div",
                                  { staticClass: "Sidebar_First_Letter" },
                                  [_c("img", { attrs: { src: menu.logo } })]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "Sidebar_First_Letter" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.getFirstChar(menu.name)) +
                                        "\n                        "
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c("span", { staticClass: "color-9cadb5" }, [
                              _vm._v(_vm._s(_vm.stringTrim(menu.name, 16)))
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "color-c3202b" }, [
                              _vm._v("(No Data)")
                            ])
                          ]
                    ],
                    2
                  )
                ]
              : [
                  _c(
                    "li",
                    {
                      staticClass: "company",
                      attrs: { id: "company_" + menu.id }
                    },
                    [
                      menu.locations.length > 0
                        ? [
                            _c(
                              "label",
                              {
                                staticClass: "tree-toggle nav-header",
                                attrs: { title: menu.name },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.toggleMenu(menu)
                                  }
                                }
                              },
                              [
                                menu.logo != ""
                                  ? _c(
                                      "div",
                                      { staticClass: "Sidebar_First_Letter" },
                                      [_c("img", { attrs: { src: menu.logo } })]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "Sidebar_First_Letter" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.getFirstChar(menu.name)
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    ),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.stringTrim(menu.name, 18)) +
                                    " "
                                ),
                                _c("i", {
                                  staticClass: "fa fa-angle-down",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass: "nav nav-list tree",
                                staticStyle: { display: "none" },
                                attrs: { id: "ul_home" }
                              },
                              [
                                _vm._l(menu.locations, function(
                                  location,
                                  index
                                ) {
                                  return [
                                    _c(
                                      "li",
                                      {
                                        attrs: { id: "location" + location.id }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              title: menu.name,
                                              to: {
                                                name: "ViewContactList",
                                                params: {
                                                  company: menu.id,
                                                  location: location.id
                                                }
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.stringTrim(
                                                    location.name,
                                                    22
                                                  )
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        : [
                            menu.logo != ""
                              ? _c(
                                  "div",
                                  { staticClass: "Sidebar_First_Letter" },
                                  [_c("img", { attrs: { src: menu.logo } })]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "Sidebar_First_Letter" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.getFirstChar(menu.name)) +
                                        "\n                    "
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c("span", { staticClass: "color-9cadb5" }, [
                              _vm._v(_vm._s(_vm.stringTrim(menu.name, 16)))
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "color-c3202b" }, [
                              _vm._v("(No Data)")
                            ])
                          ]
                    ],
                    2
                  )
                ]
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5377987f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5377987f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/partials/ExtensionSidebar.vue
// module id = null
// module chunks = 